import { useRef, useState } from 'react';
import { toast } from '@/lib/hooks/use-toast';
import { useEmpresaStore } from '../store/empresa-store';

/** 500 KB, como el servidor. Un logo de verdad pesa entre 20 y 60 KB. */
export const LOGO_MAXIMO = 500 * 1024;

/**
 * «Cambiar logo» de Mi empresa (Resumen y Documentos): PNG o JPG de hasta
 * 500 KB, guardado como data URL en la empresa. El menú y el PDF lo toman de ahí.
 */
export function useSubirLogo(alTerminar?: () => void) {
  const guardar = useEmpresaStore((s) => s.guardar);
  const archivo = useRef<HTMLInputElement>(null);
  const [subiendo, setSubiendo] = useState(false);

  const subir = async (f: File | undefined) => {
    if (!f) return;
    if (!['image/png', 'image/jpeg'].includes(f.type)) {
      toast({ title: 'El logo tiene que ser PNG o JPG', variant: 'destructive' });
      return;
    }
    if (f.size > LOGO_MAXIMO) {
      toast({ title: 'El logo pesa más de 500 KB', variant: 'destructive' });
      return;
    }
    setSubiendo(true);
    try {
      const dataUrl = await new Promise<string>((ok, mal) => {
        const lector = new FileReader();
        lector.onload = () => ok(String(lector.result));
        lector.onerror = () => mal(lector.error);
        lector.readAsDataURL(f);
      });
      await guardar({ logoUrl: dataUrl });
      toast({
        title: 'Logo actualizado',
        description: 'Ya se ve en el menú y en tus cotizaciones.',
      });
      alTerminar?.();
    } catch (e) {
      toast({
        title: 'No se pudo subir el logo',
        description: e instanceof Error ? e.message : undefined,
        variant: 'destructive',
      });
    } finally {
      setSubiendo(false);
      if (archivo.current) archivo.current.value = '';
    }
  };

  return { archivo, subiendo, subir, elegir: () => archivo.current?.click() };
}
